import { render } from "./RealizeSelfScreen.vue?vue&type=template&id=3a608c36"
import script from "./RealizeSelfScreen.vue?vue&type=script&lang=js"
export * from "./RealizeSelfScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__